import VisitorLegacyRedirect from "../components/routing/VisitorLegacyRedirect";
import EditVisitorRedirect from "../components/routing/EditVisitorRedirect";
import VisitorDetailsView from "../components/routing/VisitorDetailsView";
import { Navigate } from "react-router-dom";
import { useVisitorRole } from "./useVisitorRole";

function VisitorLegacyMastersRedirect() {
  return <VisitorLegacyRedirect hash="visitor-control-masters" />;
}

function VisitorLegacyRegisterRedirect() {
  return <VisitorLegacyRedirect hash="visitor-register" />;
}

function VisitorDashboardRedirect() {
  const perms = useVisitorRole();
  if (perms.isAdmin) {
    return <Navigate to="/app/visitors/control" replace />;
  }
  return <Navigate to="/app/visitors" replace />;
}

/**
 * Legacy visitor URLs (old bookmarks). Main screens are in screenRegistry.js.
 */
export const VISITOR_LEGACY_ROUTES = [
  {
    path: "visitors/dashboard",
    screenKey: "visitor-control",
    element: VisitorDashboardRedirect,
  },
  {
    path: "visitors/purposes/new",
    screenKey: "visitor-control",
    element: VisitorLegacyMastersRedirect,
  },
  {
    path: "visitors/purposes",
    screenKey: "visitor-control",
    element: VisitorLegacyMastersRedirect,
  },
  {
    path: "visitors/id-proof/new",
    screenKey: "visitor-control",
    element: VisitorLegacyMastersRedirect,
  },
  {
    path: "visitors/id-proof",
    screenKey: "visitor-control",
    element: VisitorLegacyMastersRedirect,
  },
  {
    path: "visitors/new",
    screenKey: "visitor-list",
    element: VisitorLegacyRegisterRedirect,
  },
  {
    path: "visitors/:id/edit",
    screenKey: "visitor-list",
    element: EditVisitorRedirect,
  },
  {
    path: "visitors/:id",
    screenKey: "visitor-list",
    element: VisitorDetailsView,
  },
];
